
import React from 'react';
import { Grid, FormControl, Select, MenuItem } from '@mui/material';
import AgyleDialog from '../../modal/agyleDialog';

const ImageDisplayDialog = ({
    open,
    onClose,
    tests, // Array of strings
    displayImagePref,
    viewDisplay,
    onSetNewPreferences,
    classesDialogContentStyle
}) => {
    return (
        <AgyleDialog
            title={"Set Image Display"}
            open={open}
            onClose={onClose}
            contentStyle={classesDialogContentStyle}
            fullWidth
            disableSave
            alignActionsCloseButtonToRight
        >
            <div>
                {tests && tests.map((name) => {
                    return <Grid container key={name} alignItems={"center"} spacing={2}>
                        <Grid item xs={6}> {name} </Grid>
                        <Grid item xs={6}>
                            <FormControl sx={{ width: "100%" }}>
                                <Select
                                    value={displayImagePref[name.toString()] || null}
                                    displayEmpty
                                    // disabled={name === "OCT"}
                                    onChange={(event) => {
                                        onSetNewPreferences(name, event.target.value);
                                    }}
                                >
                                    <MenuItem value={null}>
                                        <em>Normal</em>
                                    </MenuItem>
                                    {viewDisplay && viewDisplay.map(r => {
                                        return (<MenuItem value={r.value} key={r.name}>{r.name}</MenuItem>)
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                })
                }
            </div>
        </AgyleDialog>
    );
};

export default ImageDisplayDialog;
